<ng-container [ngSwitch]="type">
  <label *ngIf="label" class="col-form-label label-common">{{label}}
    <span class="text-danger">{{required ? ' *' : ''}}</span>
  </label>
<button *ngIf="tooltipLabel" trigger="focus" class="btn btn-link space-tooltip" tooltip="{{tooltipLabel}}"><i class="icon-info icons"></i>
</button>
<div class="" *ngSwitchDefault [ngClass]="append?'input-group':''">
  <input
    [autofocus] = "autofocus"
    autocomplete="nope"
    [formControl]="inputControl"
    (input)="onInputChange()"
    (focusout)="onFocusout()"
    (blur)="onBlur($event)"
    [readonly]="readonly"
    placeholder="{{placeholder}}"
    [required]="required"
    [min]="min"
    [max]="max"
    [maxlength]="maxLength"
    [class]="'form-control form-input ' + customClass"
    [class.is-valid]="parentControl && parentControl.touched && !parentControl.pristine && parentControl.valid && isGoodValue(parentControl.value)"
    [class.is-invalid]="parentControl && parentControl.touched && parentControl.invalid"
    #input
    id={{fieldId}}
  >
  <div class="input-group-append" *ngIf="append">
    <div class="input-group-text">{{append}}</div>
  </div>
  <div *ngIf="additionalInfo">
    {{additionalInfo}}
  </div>
  <div class="invalid-feedback"
       *ngIf="parentControl && parentControl.invalid && validationMessage" [id]="fieldId + '-invalid'">
    {{validationMessage}}
  </div>
</div>
</ng-container>
